import MuiAvatar from '@mui/material/Avatar'

const Avatar = (props) => {
	return <MuiAvatar {...props} />
}

Avatar.defaultProps = {
	...MuiAvatar.defaultProps,
}

Avatar.propTypes = {
	...MuiAvatar.propTypes,
}

export default Avatar
